import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import zhTW from "ant-design-vue/es/locale/zh_TW";
import deDE from "ant-design-vue/es/locale/de_DE";
import frFR from "ant-design-vue/es/locale/fr_FR";
import esES from "ant-design-vue/es/locale/es_ES";

export const antdLocales = {
  en: enUS,
  "zh-cn": zhCN,
  "zh-tw": zhTW,
  de: deDE,
  fr: frFR,
  es: esES,
};

export const langs = [
  // // 欧盟核心10种语言
  // enUS, frFR, deDE, esES, itIT, nlNL, daDK, svSE, elGR, plPL,
  // // 扩展5种语言
  // zhCN, jaJP, ptPT, huHU, roRO

  // mvp支持的语言
  enUS, // English
  zhCN, // Chinese
  zhTW, // Taiwanese
  deDE, // German
  frFR, // French
  esES, // Spanish
  // jaJP // Japanese
];

export const getCurrentLangMap = () => {
  const currentLocale = systemStorage.value.lang || "en";
  return langMap[currentLocale] || langMap.en;
};
